import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { db } from '@/lib/firebase/config';
import type { Indicator } from '@/lib/assessment/namatAssessment';
import { normalizeClinicalColumns } from '@/lib/tables/clinicalColumns';

// A user's clinical-table columns live on their own profile
// (users/{uid}.preferences.clinicalColumns), so the choice follows them to any
// device (#93).

export async function getClinicalColumns(userId: string): Promise<Indicator[]> {
  const data = (await getDoc(doc(db, 'users', userId))).data();
  return normalizeClinicalColumns(data?.preferences?.clinicalColumns);
}

export async function saveClinicalColumns(userId: string, columns: Indicator[]): Promise<void> {
  await updateDoc(doc(db, 'users', userId), { 'preferences.clinicalColumns': columns });
}
